module.exports = __webpack_public_path__ + "static/media/zaloLoginIcon.d1658dee.png";